import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import axios from "axios";

import { Swiper, SwiperSlide } from "swiper/react";

import {
  Navigation,
  Pagination,
  Autoplay,
} from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./GalleryPreview.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

function HomeGallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  /* =====================================================
     FETCH GALLERY
  ===================================================== */

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/gallery`,
          { params: { limit: 12 } }
        );

        if (!cancelled) {
          setItems(response.data?.data || []);
        }
      } catch (error) {
        console.error("Home gallery load error:", error);
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  /* =====================================================
     MEDIA URL HELPER
  ===================================================== */

  const getMediaUrl = (url) => {
    if (!url) return "";

    if (
      url.startsWith("http://") ||
      url.startsWith("https://")
    ) {
      return url;
    }

    return `${API_BASE_URL}${url}`;
  };

  /* =====================================================
     DON'T RENDER IF EMPTY
  ===================================================== */

  if (!loading && items.length === 0) {
    return null;
  }

  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <section className="home-gallery-section">
      <div className="home-gallery-container">

        <div className="home-gallery-header">
          <h2>Our Gallery</h2>
        </div>

        {loading ? (
          <div className="home-gallery-loading">
            <div className="home-gallery-spinner" />
          </div>
        ) : (
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={3}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {items.slice(0, 5).map((item) => {
              const mediaUrl =
                item.type === "video"
                  ? getMediaUrl(item.thumbnail_url)
                  : getMediaUrl(item.image_url);

              return (
                <SwiperSlide key={item.id}>
                  <Link
                    to="/gallery"
                    className="home-gallery-card"
                    aria-label={`View ${item.title} in gallery`}
                  >
                    {mediaUrl ? (
                      <img
                        src={mediaUrl}
                        alt={item.title || "Gallery"}
                        loading="lazy"
                      />
                    ) : (
                      <div className="home-gallery-no-media">
                        <i className="fa fa-images" />
                      </div>
                    )}

                    <div className="home-gallery-overlay" />

                    {item.type === "video" && (
                      <div className="home-gallery-play">
                        <i className="fa fa-play" />
                      </div>
                    )}
                  </Link>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}

        <div className="home-gallery-footer">
          <Link
            to="/gallery"
            className="home-gallery-view-more"
          >
            View More
            <i className="fa fa-arrow-right ms-2" />
          </Link>
        </div>

      </div>
    </section>
  );
}

export default HomeGallery;